import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres89u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres89u/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres89u/index', { params: sendParams })
  },
  getDetail (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq
    }
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres89u/detail/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres89u/dropdowns')
  },
  getDetailSubmit (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_approvno: detailParams.approvno
    }
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno
    if (isMock) return generator(mocker.detailSubmit())
    return instance().get(endpoint + '/hres89u/detailsubmit/' + params)
  },
  postSendApprove (approveParams) {
    let paramJson = {
      '0': {
        p_staappr: approveParams.flgStaappr,
        p_approvno: approveParams.approvno,
        p_chk_appr: approveParams.chk_appr,
        p_numseq: approveParams.numseq,
        p_codempid: approveParams.codempid,
        p_dtereq: approveParams.dtereq.replace(/\//g, ''),
        p_codemprc: approveParams.codemprc,
        p_codcomp: approveParams.codcomp,
        p_codpos: approveParams.codpos,
        p_dtestr: approveParams.dtestr.replace(/\//g, ''),
        p_dteend: approveParams.dteend.replace(/\//g, ''),
        p_codappr: approveParams.codappr,
        p_dteappr: approveParams.dteappr.replace(/\//g, ''),
        p_remark: approveParams.remark,
        p_flgwarn: ''
      }
    }
    let sendParams = {
      param_json: JSON.stringify(paramJson),
      remarkApprove: (approveParams.flgStaappr === 'A') ? approveParams.remark : '',
      remarkReject: (approveParams.flgStaappr === 'N') ? approveParams.remark : ''
    }
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres89u/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres89u/index.js